/**************************************************
 * Nombre:       Casilla_Avatar_Titulo_Dato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";

const Casilla_Texto = ({dato, dir, lineas = 1}) => {

    return (
        <TableCell key={dato} variant={'body'} align={dir}>
            <Typography sx={{
                color: COLORTEXTO,
                fontSize: 14,
                fontWeight: 500,
                display: '-webkit-box',
                overflow: 'hidden',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: lineas,
                textOverflow: "ellipsis",
            }}>
                {dato}
            </Typography>

        </TableCell>

    )

}
export default Casilla_Texto